<div class="container-fluid">
  <div class="row">
    <div class="modal-header border-0 offset-md-10 col-md-2">
      <button mat-button mat-dialog-close type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</div>
<div class="container-fluid mb-5">
  <div class="row">
    <div class="col-12 mt-2">
      <table
        class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
        <thead>
        <tr>
          <th>Carteira</th>
          <th>Data</th>
          <th>Última - Data hora execução</th>
          <th>Execução</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let r of resultadoCarteiras">
          <tr class="element-row">
            <td>{{ r.carteira.nome }}</td>
            <td>{{ r.dataEnquadramento | date: 'dd/MM/yyyy' }}</td>
            <td>{{ r.timeStamp | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td>{{ tipoExecucao }}</td>
            <td>{{ r.status}}</td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
    <span *ngIf="loading$ | async" class="text-center text-muted label-maps w-100">Carregando ...</span>
  </div>
</div>


